import { render } from "./App.vue?vue&type=template&id=280fdfb5&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=280fdfb5&scoped=true&lang=css"

import exportComponent from "G:\\工作项目old\\Evaluation\\Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280fdfb5"]])

export default __exports__